import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';

@Injectable()
export class PaypalInfoDialogBuilder {
  constructor(private _translateService: TranslateService) {}

  buildIntroLabel(country: string): string {
    const label =
      country === 'US'
        ? 'DIALOG.PAYMENTS.PAYPAL.US.INTRO'
        : 'DIALOG.PAYMENTS.PAYPAL.COMMON.INTRO';

    return this._translateService.instant(label);
  }

  buildListItems(country: string): List<string> {
    const items =
      country === 'US'
        ? [
            'DIALOG.PAYMENTS.PAYPAL.US.ENABLE_PAYPAL_PAYMENTS',
            'DIALOG.PAYMENTS.PAYPAL.US.CLIENT_PAYS_WITH_PAYPAL',
            'DIALOG.PAYMENTS.PAYPAL.US.RECEIVE_WITH_PAYPAL',
          ]
        : [
            'DIALOG.PAYMENTS.PAYPAL.COMMON.ENABLE_PAYPAL_PAYMENTS',
            'DIALOG.PAYMENTS.PAYPAL.COMMON.CLIENT_PAYS_WITH_PAYPAL',
            'DIALOG.PAYMENTS.PAYPAL.COMMON.RECEIVE_WITH_PAYPAL',
          ];

    const translatedItems = items.map((item) =>
      this._translateService.instant(item)
    );

    return List(translatedItems);
  }
}
